import { render, staticRenderFns } from "./ItemActions.vue?vue&type=template&id=2173a2d0&scoped=true"
import script from "./ItemActions.vue?vue&type=script&lang=ts"
export * from "./ItemActions.vue?vue&type=script&lang=ts"
import style0 from "./ItemActions.vue?vue&type=style&index=0&id=2173a2d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2173a2d0",
  null
  
)

export default component.exports